'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface GearLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: GearLayoutProps) {
    return <ServiceLayout>{children}</ServiceLayout>;
}
